import { connect } from 'react-redux';
import {
  getDashboardName,
  getDashboards,
  getSelectedDashboard,
  getUnits,
  getDashboardEditingMode,
  getDashboardCreatingMode,
} from '../../../reducers/analyticsApp';
import {
  saveDashboard,
  setDashboardName,
  updateDashboard,
  resetDashboardMode,
} from '../../../actions/dashboards/dashboards';
import DashboardCards from '../../../components/dashboards/cards/DashboardCards';

const mapStateToProps = (state) => {
  const dashboards = getDashboards(state);
  return {
    dashboardsObj: Object.fromEntries(dashboards.map((d) => [d.id, d])),
    selectedDashboard: getSelectedDashboard(state),
    dashboardName: getDashboardName(state),
    units: getUnits(state),
    isEdit: getDashboardEditingMode(state),
    isCreate: getDashboardCreatingMode(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  setDashboardName: (name) => dispatch(setDashboardName(name)),
  saveDashboard: () => dispatch(saveDashboard()),
  updateDashboard: () => dispatch(updateDashboard()),
  resetDashboardMode: () => dispatch(resetDashboardMode()),
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardCards);
